"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.P = void 0;
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importDefault(require("react"));
var lift_1 = require("../../utils/lift");
// o tipo "any" foi adicionado para manter a compatibilidade, remover quando estivermos utilizando somente o lift
var P = function (props) {
    var mapper = function () {
        if (props.medium) {
            return 'large';
        }
        return 'small';
    };
    return (react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: mapper(), fontWeight: (0, lift_1.fontWeightDefault)(props.bold), bgColor: props.bgColor }, props.children));
};
exports.P = P;
